export default __webpack_public_path__ + "static/media/mountainsDengue.e050d06a.png";